import { type PAGE_TYPE, RESULTS_STEP_PAGE_TYPES } from '@/app/common/pageType.ts';

type EvoLayoutFlags = {
  evolutionEnabled: boolean;
  evolutionResultsOnlyEnabled: boolean;
};

// Kept out of evolutionFlags.ts so client code does not pull in @lmn/lmn-commonlogic.
export const isEvoLayout = (pageType: PAGE_TYPE, flags: EvoLayoutFlags | undefined): boolean => {
  const { evolutionEnabled = false, evolutionResultsOnlyEnabled = false } = flags ?? {};

  if (RESULTS_STEP_PAGE_TYPES.includes(pageType)) {
    return evolutionEnabled || evolutionResultsOnlyEnabled;
  }

  return evolutionEnabled;
};

export const isEvoResultsLayout = (pageType: PAGE_TYPE, flags: EvoLayoutFlags | undefined): boolean =>
  RESULTS_STEP_PAGE_TYPES.includes(pageType) && isEvoLayout(pageType, flags);
